import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnChanges,
  output,
  SimpleChanges,
} from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';

import { DatasetInfo } from '@blaze-shared/api-contracts-domain';
import { BlazeTable } from '@blaze-shared/datasets-domain';
import { DatasetRow, DatasetSchema } from '@blaze-shared/schema-domain';
import { DialogModule, FormatValueModule } from '@blaze-shared/shared-feature';
import {
  ButtonIconComponent,
  PanelComponent,
  PanelRef,
  ScrollerComponent,
} from '@blaze-shared/shared-ui';
import { IconsModule } from '@blaze-shared/theming-data-access';

import { CellPreviewComponent } from './cell-preview/cell-preview.component';

@Component({
  selector: 'blaze-dataset-preview',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonIconComponent,
    DialogModule,
    FormatValueModule,
    IconsModule,
    MatMenuModule,
    MatTableModule,
    ScrollerComponent,
    CellPreviewComponent,
    PanelComponent,
  ],
  host: { class: 'data-connector-dialog' },
  templateUrl: './dataset-preview.component.html',
  styleUrls: ['./dataset-preview.component.scss'],
})
export class DatasetPreviewComponent implements OnChanges {
  private panelRef = inject(PanelRef);

  refreshDataset = output<void>();
  showPrevPage = output<void>();

  @Input() dataset?: DatasetInfo | DatasetSchema | BlazeTable;
  @Input() previewData?: DatasetRow[];
  @Input() showCloseButton = true;

  tableColumns: string[] = [];
  tableData: DatasetRow[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataset'] || changes['previewData']) {
      this.tableData = this.previewData || [];
      const row = this.tableData?.[0];
      let columnNames: string[] = [];

      if (this.dataset && 'columns' in this.dataset && this.dataset.columns?.length) {
        columnNames = this.dataset.columns.map((col) => (!col.isInternal ? col.name : ''));
      } else if (row) {
        columnNames = Object.keys(row);
      }
      this.tableColumns = columnNames.filter((name) => !name.startsWith('_') && !!name);
    }
  }

  closeDialog(): void {
    this.panelRef.close();
  }
}
